var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Actions, Effect, ofType } from '@ngrx/effects';
import { DialogService } from '../../services/dialog.service';
import * as dialogActions from '../actions/dialog.action';
import { tap } from 'rxjs/operators';
var DialogEffects = /** @class */ (function () {
    function DialogEffects(actions$, dialogService) {
        var _this = this;
        this.actions$ = actions$;
        this.dialogService = dialogService;
        this.closeDialog$ = this.actions$.pipe(ofType(dialogActions.CLOSE_DIALOG), tap(function (action) {
            return _this.dialogService.closeDialog(action.action, action.payload);
        }));
    }
    __decorate([
        Effect({ dispatch: false }),
        __metadata("design:type", Object)
    ], DialogEffects.prototype, "closeDialog$", void 0);
    return DialogEffects;
}());
export { DialogEffects };
